import React, { useState } from "react";
import Navbar from "@/components/Navbar";
import { HelpCircle, ChevronDown, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";

const QUESTIONS = [
  {
    q: "¿Qué es MarinaHub?",
    a: "Un marketplace que conecta propietarios de barcos con profesionales náuticos verificados en toda España. Publicas lo que necesitas, recibes ofertas y eliges la que más te encaje. Sin comisiones sobre los trabajos.",
  },
  {
    q: "¿MarinaHub cobra comisión por cada trabajo?",
    a: "No. La plataforma es 100% gratuita para propietarios y para profesionales. Solo cobramos si un profesional decide contratar una promoción de pago para destacar su perfil.",
  },
  {
    q: "¿Cómo funciona el pago con garantía?",
    a: "Cuando aceptas una oferta, pagas por tarjeta a través de Stripe. El importe se retiene en garantía en la plataforma. El profesional realiza el trabajo, sube fotos si procede, y tú apruebas la finalización. Solo entonces se libera el pago automáticamente al IBAN del profesional. Si algo va mal, abres una incidencia y te lo reembolsamos.",
  },
  {
    q: "¿Cómo se verifica un profesional?",
    a: "El profesional sube su DNI, certificados profesionales y seguro de responsabilidad civil desde su panel. Nuestro equipo revisa la documentación y le otorga el sello verde \"Verificado\". Este sello aparece en su perfil público, en cada oferta y en el feed de solicitudes.",
  },
  {
    q: "Soy profesional, ¿cómo cobro?",
    a: "Conectas tu cuenta de Stripe una sola vez desde /pro/connect. A partir de ese momento, cada trabajo aprobado por el cliente se transfiere automáticamente a tu IBAN en pocos días laborables. Sin comisiones para MarinaHub sobre el trabajo (solo las comisiones estándar de Stripe: 1.4% + 0.25€ para tarjetas europeas).",
  },
  {
    q: "Soy propietario, ¿cómo elijo un puerto?",
    a: "Al crear una solicitud puedes elegir tu puerto pinchando directamente en el mapa interactivo de España (219 puertos) o buscándolo por provincia y comarca. Si guardas tu barco en \"Mis barcos\" con su puerto base, las solicitudes se pueblan automáticamente.",
  },
  {
    q: "¿Los profesionales ven mi teléfono o mi email?",
    a: "Nunca. Todas las comunicaciones se hacen a través del chat integrado con filtro anti-contacto que bloquea automáticamente teléfonos, emails y redes sociales para tu seguridad. Solo cuando el trabajo está aceptado se abre el chat.",
  },
  {
    q: "¿Qué pasa si el trabajo sale mal?",
    a: "Puedes abrir una incidencia desde el detalle del trabajo. Nuestro equipo revisa el caso, contacta con las dos partes, y decide si liberar el pago al profesional o reembolsar al cliente. El dinero está en garantía hasta que se resuelva.",
  },
  {
    q: "¿Puedo tener varios barcos?",
    a: "Sí. En el menú \"Mis barcos\" añades cada uno con su nombre, eslora, año y puerto base. Cuando publiques una solicitud podrás seleccionar qué barco es. Además, en tu panel verás profesionales destacados cerca del puerto donde tienes tus barcos.",
  },
  {
    q: "¿En qué idiomas está MarinaHub?",
    a: "Español por defecto y inglés para los muchos propietarios extranjeros con barcos en España. La web detecta automáticamente el idioma de tu navegador; puedes cambiarlo con el selector ES/EN abajo a la derecha.",
  },
  {
    q: "¿Puedo instalar MarinaHub como app en mi móvil?",
    a: "Sí. Desde la landing pulsa \"Descarga la app\" y se instala como app nativa (PWA) sin pasar por App Store ni Google Play. Recibirás notificaciones push aunque tengas la web cerrada.",
  },
  {
    q: "¿Cómo contacto con soporte?",
    a: "Desde tu panel (propietario o profesional) tienes un botón \"Ayuda\" en el menú superior. Abre un chat con el equipo de MarinaHub donde puedes reportar un fallo, hacer una consulta o pedir ayuda con un pago. Te contestamos en menos de 24h.",
  },
];

function FAQItem({ q, a, idx }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="hub-card overflow-hidden">
      <button onClick={() => setOpen(!open)} className="w-full p-5 flex items-center justify-between text-left" data-testid={`faq-item-${idx}`}>
        <span className="font-serif text-lg text-[#0B1D3A]">{q}</span>
        <ChevronDown className={`text-[#5C6B7D] transition-transform ${open ? "rotate-180" : ""}`} size={18}/>
      </button>
      {open && <div className="px-5 pb-5 text-[#0B1D3A]/85 leading-relaxed">{a}</div>}
    </div>
  );
}

export default function FAQ() {
  return (
    <div className="min-h-screen hub-cream">
      <Navbar/>
      <main className="max-w-3xl mx-auto px-6 md:px-10 py-10">
        <div className="hub-pill hub-sand text-[#0B1D3A] mb-3"><HelpCircle size={12}/> Ayuda</div>
        <h1 className="font-serif text-5xl text-[#0B1D3A]">Preguntas frecuentes</h1>
        <p className="text-[#5C6B7D] mt-2">Lo más consultado. Si no encuentras tu respuesta, escríbenos.</p>

        <div className="mt-8 space-y-3">
          {QUESTIONS.map((x, i) => <FAQItem key={x.q} idx={i} {...x}/>)}
        </div>

        <div className="mt-10 hub-navy rounded-2xl p-8 relative overflow-hidden">
          <div className="relative">
            <h3 className="font-serif text-3xl text-white">¿Sigues con dudas?</h3>
            <p className="text-white/70 mt-2">Escríbenos directamente desde tu panel con el botón "Ayuda". Contestamos rápido.</p>
            <Link to="/login" className="mt-5 inline-flex items-center gap-2 hub-btn-coral hub-btn-primary" data-testid="faq-cta-login">
              <MessageCircle size={14}/> Ir a mi panel
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}
